import { render, staticRenderFns } from "./YearSelectComponent.vue?vue&type=template&id=22ac7557"
import script from "./YearSelectComponent.vue?vue&type=script&lang=js"
export * from "./YearSelectComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports